/**
 * Project : workspace
 * File    : BusinessAppWindow.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package navigation.business.window

import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Scaffold
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.navigation.NavController
import androidx.navigation.compose.NavHost
import appConfig.AppConfig
import com.parmartechnologies.communication.core.viewModel.AuthViewModel
import component.alert.AlertView
import graph.AppType
import navigation.base.FriendlyWindow
import navigation.business.botomBar.BottomNavigationBar
import navigation.commerce.route.home.CommerceHomeNavRoute
import navigation.graph.AppNavGraph
import navigation.route.business.BusinessNavRoute
import presentation.screens.common.auth.AuthContainer
import theme.FriendlyTheme
import theme.ThemeColor

/**
 * Represents the business app window class.
 */

class BusinessAppWindow(val route: String = BusinessNavRoute.LANDING): FriendlyWindow() {
    val authContainer = AuthContainer()
    @Composable
    override fun content(onNavHostReady: suspend (NavController) -> Unit) {
        super.content(onNavHostReady)
        AppConfig.shared().setBusiness()
        val authViewModel = AuthViewModel()
        val isLoggedIn = authViewModel.isLoggedIn.collectAsState()
        AppConfig.shared().appType = AppType.BUSINESS
        ThemeColor.shared().PrimaryColor = ThemeColor.shared().businessTheme

            FriendlyTheme {
                authContainer.content()
                AlertView()
                if(isLoggedIn.value || route == CommerceHomeNavRoute.STORES){
                    Scaffold(
                        bottomBar = { BottomNavigationBar(navigationController,route) },
                    ){innerPadding ->
                        NavHost(
                            navController = navigationController!!,
                            graph = AppNavGraph().appNavigationGraph(route),
                            modifier = Modifier.padding(innerPadding)
                        )
                    }
                }else{
                    Scaffold(
                    ){innerPadding ->
                        NavHost(
                            navController = navigationController!!,
                            graph = AppNavGraph().appNavigationGraph(route),
                            modifier = Modifier.padding(innerPadding)
                        )
                    }
                }
            }
        }

}